const WORDS = [
  "Own Your Power",
  "Generation",
  "Savings",
  "Service",
  "Home Energy OS",
  "Real Numbers",
  "Built for India",
];

export const Marquee = () => (
  <div className="relative bg-navy py-6 overflow-hidden border-y border-white/10" data-testid="marquee">
    <div className="flex whitespace-nowrap marquee-track will-change-transform">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {WORDS.map((w, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="display-serif text-3xl sm:text-5xl italic text-white/85 px-8">
                {w}
              </span>
              <span className="h-2.5 w-2.5 rounded-full bg-amber shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
